import { useState } from 'react';
import Modal from '../modal/modal';
import Card from '../card/Card';
import Input from '../input/Input';
import { toast } from 'react-toastify';
import { createAssetToIntegrate } from '../../services/GuaranteesService';

interface NewAssetsToIntegrateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const NewAssetsToIntegrateModal = ({
  isOpen,
  onClose,
  onSuccess,
}: NewAssetsToIntegrateModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  // Form values
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  const resetForm = () => {
    setName('');
    setDescription('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async () => {
    // Validations
    if (!name || name.trim() === '') {
      toast.error('Ingrese el nombre del activo');
      return;
    }

    if (!description || description.trim() === '') {
      toast.error('Ingrese la descripción del activo');
      return;
    }

    setIsLoading(true);
    try {
      const requestBody = {
        name: name.trim(),
        description: description.trim(),
      };

      const response = await createAssetToIntegrate(requestBody);
      
      if (response.success) {
        toast.success('Activo a integrar creado exitosamente');
        resetForm();
        onClose();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        const errorMsg = 'message' in response ? response.message : 'Error al crear activo a integrar';
        toast.error(errorMsg);
      }
    } catch (error) {
      console.error('Error creating asset to integrate:', error);
      toast.error('Error al crear activo a integrar');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Añadir nuevo activo"
      width='600px'
      primaryText='Agregar'
      primaryVariant='primary'
      onPrimaryAction={handleSubmit}
      primaryActionDisabled={isLoading}
      secondaryText='Cancelar'
      secondaryVariant='contained'
      onSecondaryAction={handleClose}
      showOverlay={true}
    >
      <Card margin={{ top: '4' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
          {/* Nombre */}
          <Input
            label="Nombre *"
            name="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isLoading}
            size="md"
          />

          {/* Descripción */}
          <Input
            label="Descripción *"
            name="description"
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            disabled={isLoading}
            size="md"
          />
        </div>
      </Card>
    </Modal>
  );
};

export default NewAssetsToIntegrateModal;
